<ng-select
  class="min-w"
  [(ngModel)]="currentTenant"
  [items]="tenants"
  name="selectTenant"
  id="tenant"
  placeholder="Selectionner une ville"
  [clearable]="false"
  (change)="onTenantChange($event)"
>
  <ng-template ng-option-tmp ng-label-tmp let-item="item">
    <span class="d-flex align-items-center">
      <avatar
        [url]="item.logoUrl"
        [avatar]="item.logoUrl"
        [fullName]="item.name"
        [size]="26"
      ></avatar>

      <span class="ml-1"> {{ item.name }}</span>
    </span>
  </ng-template>
</ng-select>
